import { Routes } from '@angular/router';
import { PrecallSettings } from './models/app/precall-settings';
import { PrecallPageComponent } from './pages/precall-page/precall-page.component';
import { environment } from '../environments/environment.development';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/user',
    pathMatch: 'full',
  },
  {
    path: 'user',
    component: PrecallPageComponent,
    data: {
      report: true,
      limitBandWidth: 3.5,
      audioOnly: true,
      debug: !environment.production,
    } as PrecallSettings,
  },
  {
    path: 'system',
    component: PrecallPageComponent,
    data: {
      report: false,
      limitBandWidth: 6.0,
      audioOnly: false,
      debug: !environment.production,
    } as PrecallSettings,
  },
  { path: '**', component: NotFoundPageComponent },
];
